const API_BASE_URL = import.meta.env.VITE_ARRIVALS_API_URL as string;

export async function customFetch<T>(
  url: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${url}`, options);

  if (!response.ok) {
    const err = Object.assign(
      new Error(`API error: ${response.status.toString()}`),
      {
        status: response.status,
      },
    );
    throw err;
  }

  return response.json() as Promise<T>;
}
